// ─────────────────────────────────────────────────────────────────────────
// MedioPagoModal (28-ago-2026, auditoría UX) — reemplaza el window.prompt
// al marcar una factura de compra como pagada. Mini-modal con presets
// (transferencia / tarjeta / caja) + campo libre. Lo usan Contabilidad
// (panel de la factura) y la pestaña Pagos.
//
// Props:
//   open       boolean
//   titulo     string  — ej: "Marcar pagada · F° 4581"
//   subtitulo  string  — ej: "FERRETERÍA X · $120.000" (opcional)
//   onConfirm  async (medio) => void  — se llama con el medio elegido/escrito
//   onCancel   () => void
// ─────────────────────────────────────────────────────────────────────────
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

const PRESETS = ["transferencia", "tarjeta", "caja"];

const MedioPagoModal = ({ open, titulo, subtitulo, onConfirm, onCancel }) => {
  const [medio, setMedio] = useState("transferencia");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (open) { setMedio("transferencia"); setEnviando(false); }
  }, [open]);

  if (!open) return null;

  const confirmar = async () => {
    if (enviando) return;
    setEnviando(true);
    try { await onConfirm?.(medio.trim() || "transferencia"); }
    finally { setEnviando(false); }
  };

  return ReactDOM.createPortal(
    <div
      style={{ position: "fixed", inset: 0, zIndex: 1500, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", padding: 12 }}
      onClick={() => !enviando && onCancel?.()}
    >
      <div
        onClick={e => e.stopPropagation()}
        style={{ width: "min(360px, 94vw)", background: "#1e1e1e", border: "1px solid #2e2e2e", borderRadius: 12, padding: 18 }}
      >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 4 }}>
          <div style={{ fontSize: 15, fontWeight: 800, color: "#fff" }}>{titulo || "Medio de pago"}</div>
          <button onClick={() => !enviando && onCancel?.()} style={{ background: "none", border: "none", color: "#999", fontSize: 20, cursor: "pointer" }}>×</button>
        </div>
        {subtitulo && <div style={{ fontSize: 11, color: "#8a8a8a", marginBottom: 12 }}>{subtitulo}</div>}

        <div style={{ fontSize: 10, fontWeight: 700, color: "#8a8a8a", textTransform: "uppercase", letterSpacing: ".05em", marginBottom: 6 }}>
          ¿Con qué se pagó?
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
          {PRESETS.map(p => (
            <button key={p} type="button" className="chip-touch no-touch-min t-02"
              onClick={() => setMedio(p)}
              style={{
                background: medio === p ? "#3a1114" : "#1e1e1e",
                color: medio === p ? "#ff8a8f" : "#999",
                border: `1px solid ${medio === p ? "#e30613" : "#333"}`,
                borderRadius: 6, padding: "6px 14px", fontSize: 12, cursor: "pointer",
              }}>
              {p}
            </button>
          ))}
        </div>
        <input
          value={medio}
          onChange={e => setMedio(e.target.value)}
          placeholder="u otro medio (cheque, efectivo…)"
          style={{ width: "100%", background: "#161616", border: "1px solid #333", borderRadius: 6, padding: "8px 10px", fontSize: 12, color: "#ddd", boxSizing: "border-box", fontFamily: "Arial,sans-serif", marginBottom: 14 }}
        />

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
          <button type="button" onClick={() => onCancel?.()} disabled={enviando}
            style={{ background: "transparent", color: "#cbd5e1", border: "1px solid #444", borderRadius: 8, padding: "8px 16px", fontSize: 12, cursor: "pointer" }}>
            Cancelar
          </button>
          <button type="button" onClick={confirmar} disabled={enviando}
            style={{ background: enviando ? "#333" : "#0d2a15", color: enviando ? "#999" : "#2ecc71", border: "1px solid #0d4020", borderRadius: 8, padding: "8px 16px", fontSize: 12, fontWeight: 700, cursor: enviando ? "not-allowed" : "pointer" }}>
            {enviando ? "Guardando…" : "✓ Confirmar pago"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default MedioPagoModal;
